import BaseService from '../base';
import {
  IRoomInfoRequest,
  IRoomOnlineRequest,
  IPlayUrlRequest,
  IActionReportRequest,
  IUserCardRequest,
  ISetUserMuteStateRequest,
  IHeartbeatRequest,
} from './types';
import { isHttpsPage } from '@/utils';

class RoomService extends BaseService {
  getRoomInfo(roomId: number) {
    const url = '/web/live/room/info';
    const params: IRoomInfoRequest = {
      room_id: roomId,
    };
    return this.get({ url, params });
  }

  getRoomOnline(roomId: number) {
    const url = '/web/live/room/online';
    const params: IRoomOnlineRequest = {
      room_id: roomId,
    };
    return this.get({ url, params });
  }

  getLivePlayURL(roomId: number, qn?: number) {
    const url = '/web/live/playurl';
    const params: IPlayUrlRequest = {
      room_id: roomId,
      qn,
      https_url_req: isHttpsPage(),
    };
    return this.get({ url, params });
  }

  actionReport(type: number, roomId: number) {
    const url = '/web/live/comment/action_report';
    const data: IActionReportRequest = {
      type,
      room_id: roomId,
    };
    return this.postForm({ url, data });
  }

  // 心跳上报，统计观看直播的时长
  reportHeartbeat(params: IHeartbeatRequest) {
    const url = '/intl/gateway/web/data/report/heartbeat';
    return this.postJson({ url, params }).catch(e => console.log('[reportHeartbeat error]', e));
  }

  getUserCard(roomId: number, mid: number, source: number) {
    const url = '/web/live/room/usercard';
    const params: IUserCardRequest = {
      room_id: roomId,
      mid,
      source
    };
    return this.get({ url, params });
  }

  setUserMuteState(roomId: number, mid: number, state: number) {
    const url = '/web/live/room/mute';
    const data: ISetUserMuteStateRequest = {
      room_id: roomId,
      mid,
      state,
    };
    return this.postForm({ url, data });
  }

  setUserAdminState(roomId: number, mid: number, state: number) {
    const url = '/web/live/room/op_admin';
    const data: ISetUserMuteStateRequest = {
      room_id: roomId,
      mid,
      state,
    };
    return this.postForm({ url, data });
  }

  getRechargeBarInfo(roomId: number) {
    const url = '/web/live/room/recharge_bar/info';
    const params = {
      room_id: roomId
    };
    return this.get({ url, params });
  }

  getRechargeBarReward() {
    const url = '/web/live/room/recharge_bar/reward_record';
    return this.get({ url });
  }

  completeFollow(roomId: number) {
    const url = '/web/live/room/recharge_bar/follow/complete';
    const data = {
      room_id: roomId
    };
    return this.postForm({ url, data });
  }

}

export default new RoomService();
